module.exports = "/assets/9be6f9acc3073fef47e22e7d5a738954.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/2L.png
// module id = 2118
// module chunks = 0